const countFreeSlots = <T>(xs: T[], max: number): number => Math.max(max - xs.length, 0);

export default countFreeSlots;
